export default __webpack_public_path__ + "static/media/testimoni3.5298fee3.webp";